import { jsx as o } from "react/jsx-runtime";
import { useCallback as e } from "react";
import { toast as f } from "react-hot-toast";
import { QuestionMarkIcon as c } from "../../../icons/question-mark-icon.mjs";
import { ToastContainer as u } from "../components/toast-container.mjs";
const b = ({
  className: t,
  titleClassName: r,
  buttonClassName: s
} = {}) => ({ infoToast: e(
  (m, a, i, n) => f.custom(
    (p) => /* @__PURE__ */ o(
      u,
      {
        t: { ...p, message: m },
        className: t,
        titleClassName: r,
        buttonClassName: s,
        afterClose: i,
        hideCloseButton: n
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ o(c, { className: "fill-brand-primary h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
      ...a
    }
  ),
  []
) });
export {
  b as useCustomToasts
};
